import { connect } from 'react-redux';
import { ApplicationState } from '../../../redux/reducers';
import ResetPassword from './ResetPassword';
// import { reduxForm } from 'redux-form';
import { resetPasswordRequest, resetPassword } from '../../../redux/auth/creators';
import { addToast } from '../../../redux/ui/creators';
interface StateProps {
  auth: any;
}

interface DispatchProps {
  resetPasswordRequest: Function;
  resetPassword: Function;
  addToast: Function;
}

interface OwnProps {}

export type AllProps = StateProps & DispatchProps & OwnProps;

const mapStateToProps = (state: ApplicationState) => {
  return {
    auth: state.auth
  }
}

function mapDispatchToProps(dispatch: any): DispatchProps {
  return {
    resetPasswordRequest: dispatch(resetPasswordRequest),
    resetPassword: dispatch(resetPassword),
    addToast: dispatch(addToast),
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ResetPassword);